module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-17-03-296.1cb672d8.mp4";